import type { MailboxInfo } from 'owa-client-types';
import type { Capability } from 'owa-capabilities';
import { RegisterForAccountStateChange } from 'owa-account-source-list';
import { type AccountSource } from 'owa-account-source-list-store';
import { areAnyAccountsEnterpriseOrPremiumConsumer } from './utils/areAnyAccountsEnterpriseOrPremiumConsumer';

let checked = false;
let enabled = false;

/**
 * This capability is used to determine if advanced flag is supported in OWA/Monarch
 */
export const advancedFlagCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        if (checked) {
            return enabled;
        }

        enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
        checked = true;

        RegisterForAccountStateChange(onAccountsChanged, onAccountsChanged);
        return enabled;
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
};

// Callback for when an account is added or removed
const onAccountsChanged = async (_accountSource: AccountSource) => {
    enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
};
